import { createContext, useContext } from "react";

export const MOBILE_SHELL_MAX_WIDTH = 1024;

const ShellMenuContext = createContext({
  mobileMenuOpen: false,
  toggleMobileMenu: () => {},
  closeMobileMenu: () => {},
});

export function useShellMenu() {
  return useContext(ShellMenuContext);
}

export function isMobileShellWidth(width) {
  const value = width != null ? width : typeof window !== "undefined" ? window.innerWidth : 0;
  return value <= MOBILE_SHELL_MAX_WIDTH;
}

export default ShellMenuContext;
